import React from "react";
import { Image } from "@mantine/core";

interface SimpleImageProps {
  src: string; // Only pass the relative part of the path
  h: number;
}

const SimpleImage: React.FC<SimpleImageProps> = ({ src, h }) => {
  const basePath = "https://daxwktpz4hkwd.cloudfront.net/";
  const filename = src.split("/").pop()?.split(".")[0] || "";
  const altText = filename.replace(/-/g, " ");

  return (
    <div
      style={{
        display: "inline-block",
        border: "1px solid #495057",
        borderRadius: "0.25rem",
        overflow: "hidden", // Ensures rounded corners match the image
      }}
    >
      <Image h={h} fit="contain" src={`${basePath}${src}`} alt={altText} />
    </div>
  );
};

export default SimpleImage;
